// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck
import cx from 'classnames';
import { urlForImage } from '@lib/sanity';
import { SaneImage, BrowserFrame } from '@components';

export function Image({ node }) {
  const widthClass = node.width ? 'w-[' + node.width + 'px]' : undefined;
  const browserClass = 'drop-shadow-lg overflow-hidden max-h-[600px]';

  if (node.type === 'Browser') {
    const url = urlForImage(node.asset).url();

    return (
      <figure
        className={cx('m-auto text-center my-12', widthClass, browserClass)}
      >
        <BrowserFrame />
        <div className="not-prose">
          <img alt={node.alt} src={url} />
        </div>
      </figure>
    );
  }

  return (
    <figure className={cx('m-auto text-center', widthClass)}>
      <SaneImage
        src={node}
        width={node.width}
        wrapClassName={node.width ? 'image-wrap m-auto' : undefined}
      />
      {node.caption && <figcaption>{node.caption}</figcaption>}
    </figure>
  );
}
